import React from 'react';
import Sheet from '../ui/Sheet';
import Icon from '../ui/Icon';
import './SkillDetailModal.css';

const STATE_LABEL = {
  mastered: 'Mastered', strong: 'Strong', improving: 'Improving',
  needs_attention: 'Needs Attention', declining: 'Declining', insufficient_data: 'Building Evidence',
};

const TREND = {
  improving: { icon: 'trend-up', text: 'Improving' },
  declining: { icon: 'trend-down', text: 'Declining' },
  stable: { icon: 'trend-flat', text: 'Holding steady' },
};

// Progressive disclosure over topicIntelligenceService's real per-topic
// output — every field here already exists in that response; nothing is
// recomputed or reinterpreted. "What should I understand about this skill?"
// drives what's shown: state, accuracy, trend, attempts, speed, mistake
// pattern, then the same real explanation/action the recommendation engine
// would otherwise build from this exact evidence. Shown as a bottom sheet.
const SkillDetailModal = ({ topic, onClose }) => {
  const hasEvidence = topic.state !== 'insufficient_data';
  const trend = TREND[topic.trend?.label];

  return (
    <Sheet open onClose={onClose} label={`${topic.topic_name} skill detail`}>
      <div className="sdm-content">
        <span className={`sdm-state-badge sdm-state-badge--${topic.state}`}>{STATE_LABEL[topic.state]}</span>
        <h2 className="sdm-title">{topic.topic_name}</h2>

        {hasEvidence ? (
          <>
            <div className="sdm-stats-row">
              <div className="sdm-stat">
                <span className="sdm-stat-val">{Math.round(topic.evidence.accuracy_confidence_adjusted_pct)}%</span>
                <span className="sdm-stat-label">Accuracy</span>
              </div>
              <div className="sdm-stat">
                <span className="sdm-stat-val">{topic.evidence.attempts}</span>
                <span className="sdm-stat-label">Attempts</span>
              </div>
              {topic.speed?.is_slow != null && (
                <div className="sdm-stat">
                  <span className="sdm-stat-val">{topic.speed.is_slow ? 'Slower' : 'On pace'}</span>
                  <span className="sdm-stat-label">Speed</span>
                </div>
              )}
            </div>

            {trend && <p className="sdm-trend"><Icon name={trend.icon} size={16} /> {trend.text}</p>}

            {topic.mistakes && (topic.mistakes.unresolved > 0 || topic.mistakes.resolved > 0) && (
              <div className="sdm-mistakes">
                {topic.mistakes.repeated_unresolved > 0 && <span className="sdm-mistake-chip sdm-mistake-chip--warn">{topic.mistakes.repeated_unresolved} recurring mistake{topic.mistakes.repeated_unresolved === 1 ? '' : 's'}</span>}
                {topic.mistakes.unresolved - topic.mistakes.repeated_unresolved > 0 && <span className="sdm-mistake-chip">{topic.mistakes.unresolved - topic.mistakes.repeated_unresolved} to recover</span>}
                {topic.mistakes.recently_corrected > 0 && <span className="sdm-mistake-chip sdm-mistake-chip--good">{topic.mistakes.recently_corrected} recently corrected</span>}
              </div>
            )}

            {topic.explanation && <p className="sdm-explanation">{topic.explanation}</p>}
          </>
        ) : (
          <p className="sdm-explanation">
            Not enough evidence yet on this topic — a few more questions here will start building a real picture.
          </p>
        )}
      </div>
    </Sheet>
  );
};

export default SkillDetailModal;
